import { createBrowserRouter, Navigate } from "react-router-dom";

import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { RouteError } from "@/components/RouteError";
import { DashboardPage } from "@/pages/DashboardPage";
import { LoginPage } from "@/pages/LoginPage";
import { AdminUsersPage } from "@/pages/admin/AdminUsersPage";
import { BrandsPage } from "@/pages/admin/BrandsPage";
import { OnecSettingsPage } from "@/pages/admin/OnecSettingsPage";
import { OneCBasesAdminPage } from "@/pages/admin/OneCBasesAdminPage";
import { PromptsPage } from "@/pages/admin/PromptsPage";
import { OrdersPage } from "@/pages/orders/OrdersPage";
import { OzonAnalyticsPage } from "@/pages/ozon-analytics/OzonAnalyticsPage";
import { ReviewQueuePage } from "@/pages/reviews/ReviewQueuePage";
import { ReviewsDashboardPage } from "@/pages/reviews/ReviewsDashboardPage";
import { ProductDevPage } from "@/pages/product-dev/ProductDevPage";
import { PurchasePricesPage } from "@/pages/purchase-prices/PurchasePricesPage";
import { Connection1CPage } from "@/pages/settings/Connection1CPage";
import { SupplyPage } from "@/pages/supply/SupplyPage";
import { OzonSupplyDetailPage } from "@/pages/supply/ozon/OzonSupplyDetailPage";
import { WbRegionsPage } from "@/pages/wb-regions/WbRegionsPage";
import { WholesalePage } from "@/pages/wholesale/WholesalePage";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    errorElement: <RouteError />,
    children: [
      { index: true, element: <DashboardPage /> },
      {
        path: "reviews",
        element: (
          <ProtectedRoute requirePermission="reviews">
            <ReviewQueuePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "reviews/dashboard",
        element: (
          <ProtectedRoute requirePermission="reviews">
            <ReviewsDashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "supply",
        element: (
          <ProtectedRoute requirePermission="supply">
            <SupplyPage />
          </ProtectedRoute>
        ),
      },
      {
        // страница одной поставки Ozon: список остаётся вкладкой `/supply?tab=ozon`, а сюда
        // ходят по прямой ссылке — со списка, из чата и харнессом скриншотов
        path: "supply/ozon/:shipmentId",
        element: (
          <ProtectedRoute requirePermission="supply">
            <OzonSupplyDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "orders",
        element: (
          <ProtectedRoute requirePermission="orders">
            <OrdersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "ozon-analytics",
        element: (
          <ProtectedRoute requirePermission="ozon_analytics">
            <OzonAnalyticsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "wholesale",
        element: (
          <ProtectedRoute requirePermission="wholesale_analytics">
            <WholesalePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "wb-regions",
        element: (
          <ProtectedRoute requirePermission="wb_regions">
            <WbRegionsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "purchase-prices",
        element: (
          <ProtectedRoute requirePermission="purchase_prices">
            <PurchasePricesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "product-dev",
        element: (
          <ProtectedRoute requirePermission="product_dev">
            <ProductDevPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "product-dev/:projectId",
        element: (
          <ProtectedRoute requirePermission="product_dev">
            <ProductDevPage />
          </ProtectedRoute>
        ),
      },
      { path: "settings/1c", element: <Connection1CPage /> },
      {
        path: "admin/prompts",
        element: (
          <ProtectedRoute requireAdmin>
            <PromptsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "admin/brands",
        element: (
          <ProtectedRoute requireAdmin>
            <BrandsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "admin/onec",
        element: (
          <ProtectedRoute requireAdmin>
            <OnecSettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "admin/onec-bases",
        element: (
          <ProtectedRoute requireAdmin>
            <OneCBasesAdminPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "admin/users",
        element: (
          <ProtectedRoute requireAdmin>
            <AdminUsersPage />
          </ProtectedRoute>
        ),
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
